import { render } from "./mga-real-money-balance-page-list-filter.vue?vue&type=template&id=3bbc4f20&ts=true"
import script from "./mga-real-money-balance-page-list-filter.ts?vue&type=script&lang=ts"
export * from "./mga-real-money-balance-page-list-filter.ts?vue&type=script&lang=ts"

import "./mga-real-money-balance-page-list-filter.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__